import "core-js/modules/es6.object.define-property";

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import classNames from 'classnames';
import React from 'react';
import Type from '@nerdwallet/react-typography';
import style from './tabs.module.less';
var Tab = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var className = props.className,
      label = props.label,
      active = props.active,
      onClick = props.onClick;
  return /*#__PURE__*/React.createElement("button", {
    role: "tab",
    type: "button",
    className: classNames([className, style.tab, _defineProperty({}, style.active, active)]),
    onClick: onClick,
    ref: ref
  }, /*#__PURE__*/React.createElement(Type, {
    size: "1",
    bold: true,
    uppercase: true,
    className: style.tabName
  }, label));
});
Tab.displayName = 'Tab';

if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line global-require
  var PropTypes = require('prop-types');
  /* eslint-disable react/no-unused-prop-types */


  Tab.propTypes = {
    /** The label for this tab (required) */
    label: PropTypes.string.isRequired,

    /** Whether or not this tab is active (will be auto-generated by the <Tabs> component) */
    active: PropTypes.bool,

    /** Class name(s) to apply to the component */
    className: PropTypes.string,

    /** The click handler for this tab (will be auto-generated by the <Tabs> component) */
    onClick: PropTypes.func,

    /** The click handler for this tab which will be called in the <Tabs> component */
    onTabClick: PropTypes.func,

    /** Can be used to override the default tracking props. Note: this is implemented in tabs-component.jsx. */
    trackingProps: PropTypes.shape({
      sectionCategory: PropTypes.string,
      elementContent: PropTypes.string,
      elementName: PropTypes.string,
      elementPosition: PropTypes.string
    })
  };
}

Tab.defaultProps = {
  active: false,
  className: null,
  onClick: function onClick() {},
  onTabClick: function onTabClick() {},
  trackingProps: {}
};
/* eslint-enable react/no-unused-prop-types */

export default Tab;